import { db } from '../firebase/firebase-config';

// Catálogo de ladas por zona horaria
const LADAS_POR_ZONA = {
    'America/Mexico_City': '521',
    'America/Monterrey': '521',
    'America/Merida': '521',
    'America/Hermosillo': '521',
    'America/Chihuahua': '521',
    'America/Mazatlan': '521',
    'America/Tijuana': '521',
    'America/Bogota': '57',
    'America/Lima': '51',
    'America/Santiago': '56',
    'America/Buenos_Aires': '54',
    'America/Argentina/Buenos_Aires': '54',
    'America/Sao_Paulo': '55',
    'America/Caracas': '58',
    'America/Guayaquil': '593',
    'America/La_Paz': '591',
    'America/Asuncion': '595',
    'America/Montevideo': '598',
    'America/Panama': '507',
    'America/Costa_Rica': '506',
    'America/Guatemala': '502',
    'America/Tegucigalpa': '504',
    'America/Managua': '505',
    'America/El_Salvador': '503',
    'America/Santo_Domingo': '1809',
    'America/Havana': '53',
    'America/Puerto_Rico': '1787',
};

export const getLadaPorZona = (zonaHoraria) => {
    return LADAS_POR_ZONA[zonaHoraria] || '521';
};

export const esMexico = (zonaHoraria) => {
    return zonaHoraria && zonaHoraria.startsWith('America/') &&
        getLadaPorZona(zonaHoraria) === '521';
};

// Quita acentos y espacios para el hashtag
const removeAccents = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const nameInHashtag = async (name) => {
    if (!name) return '';
    let hashtag = '#' + removeAccents(name).replaceAll(' ', '');

    let empresas = [];
    const query = db.collection('general')
        .orderBy('hashtag')
        .startAt(hashtag)
        .endAt(hashtag + '\uf8ff');
    const snap = await query.get();
    snap.forEach(doc => empresas.push({ id: doc.id, ...doc.data() }));

    let c = 1;
    if (empresas.length > 0) {
        for (let i = 0; i < empresas.length; i++) {
            const htagI = empresas[i].id;
            if (hashtag === htagI || htagI.indexOf(hashtag + '_') !== -1) c++;
        }
        if (c > 1) hashtag += '_' + c;
    }

    return hashtag;
};

// Formatea número de consultor: quita espacios y agrega @
export const nameInArroba = (name) => {
    if (!name) return '';
    return '@' + name.replaceAll(' ', '');
};

// Detecta zona horaria del navegador
export const getZonaHoraria = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Obtiene datos de empresa por uid
export const getEmpresaByUid = async (uid) => {
    if (!uid) return null;
    const snap = await db.collection('general').where('uid', '==', uid).limit(1).get();
    if (snap.empty) return null;
    const doc = snap.docs[0];
    return { id: doc.id, ...doc.data() };
};

// Bancos México — lista completa SPEI / BANXICO
export const BANCOS_MEXICO = [
    // Los más comunes para el público general
    'BBVA',
    'Banamex (Citibanamex)',
    'Santander',
    'Banorte',
    'HSBC',
    'Scotiabank',
    'Banco Azteca',
    'BanCoppel',
    'Nu Bank (Nu México)',
    'Mercado Pago',
    'Hey Banco',
    'Spin by OXXO',
    'Kueski Pay',
    // Banca múltiple
    'Inbursa',
    'Banbajío',
    'Banregio',
    'Mifel',
    'Multiva',
    'Afirme',
    'Bansi',
    'Invex',
    'Autofin',
    'Bansí',
    'Consubanco',
    'ABC Capital',
    'Banco Famsa',
    'Bankaool',
    'Base',
    'Compartamos Banco',
    'Inmobiliario Mexicano',
    'Pagatodo',
    'Reforma',
    'Sabadell',
    'Ve por Más',
    'Bancrea',
    // Banca de desarrollo
    'Banobras',
    'Banjército',
    'Bancomext',
    'NAFIN',
    'BANSEFI (Banco del Bienestar)',
    // Instituciones de fondos de pago electrónico
    'STP',
    'Clip',
    'Conekta',
    'Cuenca',
    'Pagando',
    'Saldo',
    'Transfer',
    'Uala',
    'Walmart (Cashi)',
];

// Días de la semana
export const DIAS_SEMANA = [
    { id: 'lunes', label: 'Lunes' },
    { id: 'martes', label: 'Martes' },
    { id: 'miercoles', label: 'Miércoles' },
    { id: 'jueves', label: 'Jueves' },
    { id: 'viernes', label: 'Viernes' },
    { id: 'sabado', label: 'Sábado' },
    { id: 'domingo', label: 'Domingo' },
];
